import styled from 'styled-components'

export const VectorTileMapContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const MapWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`

export const TooltipContainer = styled.div<{ $x: number; $y: number }>`
  position: absolute;
  left: ${({ $x }) => $x}px;
  top: ${({ $y }) => $y}px;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors?.border || '#e5e5e5'};
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  pointer-events: none;
  max-width: 300px;
  transform: translate(-50%, -100%);
  margin-top: -20px; /* Increased to account for price label */

  /* Mobile responsive adjustments */
  @media (max-width: 768px) {
    max-width: 250px;
    padding: 8px;
    font-size: 14px;

    /* Adjust position for mobile */
    left: 50%;
    transform: translateX(-50%);
  }

  @media (max-width: 480px) {
    max-width: 200px;
    padding: 6px;
    font-size: 12px;
  }

  /* Tooltip arrow */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid white;
  }

  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 7px solid ${({ theme }) => theme.colors?.border || '#e5e5e5'};
    margin-top: 1px;
  }
`

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-size: 14px;
  color: ${({ theme }) => theme.colors?.text?.secondary || '#6b6b6b'};
`

export const ErrorOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  font-size: 14px;
  color: #ff3b30;
  text-align: center;
  padding: 20px;
`
